function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useSelector } from 'react-redux';
import { useSearch } from '@keen.io/react-hooks';
import { createTree } from '@keen.io/ui-core';
import { Operator } from './Filters.styles';
import FiltersContext from './FiltersContext';
import { Filter } from './components';
import Badge from '../Badge';
import { getCollectionSchema } from '../../modules/events';
import { SearchContext } from '../../contexts';
import { setOperator, setDefaultValue } from './utils';
import { AND_OPERATOR } from './constants';
import { SCHEMA_PROPS } from '../../constants';
var operatorMotion = {
  initial: {
    opacity: 0,
    x: -100
  },
  animate: {
    opacity: 1,
    x: 0
  },
  exit: {
    opacity: 0,
    x: 0
  }
};

var FiltersComponent = function FiltersComponent(_ref) {
  var collection = _ref.collection,
      filters = _ref.filters,
      _onRemove = _ref.onRemove,
      onReset = _ref.onReset,
      _onChange = _ref.onChange,
      funnelStepId = _ref.funnelStepId;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      searchPropertiesPhrase = _useState2[0],
      setSearchPhrase = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      expandTree = _useState4[0],
      setTreeExpand = _useState4[1];

  var _useSelector = useSelector(function (state) {
    return getCollectionSchema(state, collection);
  }),
      collectionSchema = _useSelector.schema,
      schemaTree = _useSelector.tree,
      schemaList = _useSelector.list;

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      propertiesTree = _useState6[0],
      setPropertiesTree = _useState6[1];

  var _useSearch = useSearch(schemaList, function (searchResult, phrase) {
    if (phrase) {
      var searchTree = {};
      searchResult.forEach(function (_ref2) {
        var path = _ref2.path,
            type = _ref2.type;
        searchTree[path] = type;
      });
      setSearchPhrase(phrase);
      setPropertiesTree(createTree(searchTree));
      setTreeExpand(true);
    } else {
      setTreeExpand(false);
      setPropertiesTree(null);
    }
  }, {
    keys: ['path', 'type'],
    threshold: 0.4
  }),
      searchHandler = _useSearch.searchHandler;

  useEffect(function () {
    return function () {
      onReset && onReset();
    };
  }, []);
  return React.createElement(SearchContext.Provider, {
    value: {
      expandTree: expandTree,
      searchPropertiesPhrase: searchPropertiesPhrase
    }
  }, React.createElement(FiltersContext.Provider, {
    value: {
      schema: collectionSchema
    }
  }, filters.map(function (filter, idx, collection) {
    return React.createElement(React.Fragment, {
      key: "fragment-".concat(filter.id)
    }, React.createElement(Filter, {
      id: filter.id,
      key: "filter-".concat(filter.id),
      filter: filter,
      properties: propertiesTree ? propertiesTree : schemaTree,
      onSearchProperties: searchHandler,
      onPropertyChange: function onPropertyChange(propertyName) {
        var schemaType = collectionSchema[propertyName];
        var inferredType = SCHEMA_PROPS[schemaType];
        var operator = setOperator(inferredType, filter.operator);

        _onChange(filter.id, {
          propertyName: propertyName,
          propertyType: inferredType,
          operator: operator,
          propertyValue: setDefaultValue(inferredType, operator)
        });

        setSearchPhrase(null);
        setPropertiesTree(schemaTree);
      },
      onRemove: function onRemove() {
        return _onRemove(filter.id);
      },
      onChange: function onChange(filter) {
        return _onChange(filter.id, filter);
      },
      funnelStepId: funnelStepId
    }), React.createElement(AnimatePresence, null, idx + 1 !== collection.length && React.createElement(motion.div, Object.assign({
      key: "operator-".concat(filter.id)
    }, operatorMotion), React.createElement(Operator, null, React.createElement(Badge, null, AND_OPERATOR)))));
  })));
};

export default FiltersComponent;